<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{ color }}">
						<h4 class="card-title"><mat-icon class="cursor-pointer" (click)="back()">arrow_back</mat-icon> Expense by Department</h4>
					</div>
					<div class="card-body">
						<form [formGroup]="formGroup" *ngIf="formGroup">
							<div class="row">
								<div class="col-md-4">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>From Period</mat-label>
										<mat-select formControlName="from_period" (selectionChange)="updateToOptions($event.value)">
											<mat-option *ngFor="let period of from_period_options" [value]="period.periodno">{{ period.lastdate_in_period }}</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-md-4">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>To Period</mat-label>
										<mat-select formControlName="to_period" (selectionChange)="updateFromOptions($event.value)">
											<mat-option *ngFor="let period of to_period_options" [value]="period.periodno">{{ period.lastdate_in_period }}</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-md-4">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Department (filter)</mat-label>
										<mat-select formControlName="gl_tag">
											<mat-option [value]="null">All departments</mat-option>
											<mat-option *ngFor="let tag of tags" [value]="tag">{{ tag.description }}</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-md-12 mt-2">
									<button mat-raised-button color="accent" (click)="runReport()">Run</button>
									<button mat-raised-button color="primary" class="ml-2" *ngIf="report?.by_department?.length" (click)="exportExcel()">Export Excel</button>
								</div>
							</div>
						</form>

						<div class="row mt-3" *ngIf="loading">
							<div class="col-md-12 text-center">
								<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
									<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
								</svg>
							</div>
						</div>

						<div class="row mt-3" *ngIf="report && !loading">
							<div class="col-md-12">
								<h5>{{ title }}</h5>
								<div class="table-responsive" *ngIf="report.by_department?.length">
									<table class="table table-striped table-sm">
										<thead>
											<tr>
												<th>Department</th>
												<th>Account</th>
												<th>Account Name</th>
												<th class="text-right">Amount</th>
											</tr>
										</thead>
										<tbody>
											<ng-container *ngFor="let dept of report.by_department">
												<tr class="font-weight-bold">
													<td>{{ dept.tagdescription }}</td>
													<td colspan="2"></td>
													<td class="text-right">{{ dept.total | currency }}</td>
												</tr>
												<tr *ngFor="let acc of dept.accounts">
													<td></td>
													<td>{{ acc.accountcode }}</td>
													<td>{{ acc.accountname }}</td>
													<td class="text-right">{{ acc.amount | currency }}</td>
												</tr>
											</ng-container>
											<tr class="font-weight-bold">
												<td>Total</td>
												<td colspan="2"></td>
												<td class="text-right">{{ report.total | currency }}</td>
											</tr>
										</tbody>
									</table>
								</div>
								<p *ngIf="report.by_department && !report.by_department.length" class="text-muted">No expense data for the selected period.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
